import {BehaviorSubject} from "rxjs";
import {EventEmitter} from "@angular/core";
import {HttpParams} from "@angular/common/http";

export class WhatsappOutgoingMsgLogFilter {

  anyChange:EventEmitter<any> = new EventEmitter<any>();

  constructor(filter?:any) {
    if (!filter) {
      this.clear();
    } else {
      this.chatCarrierIdChange.next(filter.chatCarrierId || '');
      this.companyIdChange.next(filter.companyId || '');
      this.userIdChange.next(filter.userId || '');
      this.batchIdChange.next(filter.batchId || '');
      this.fromMsisdnChange.next(filter.fromMsisdn || '');
      this.toMsisdnChange.next(filter.toMsisdn || '');
      this.typeChange.next(filter.type || '');
      this.textChange.next(filter.text || '');
      this.statusChange.next(filter.status || '');
      this.errorChange.next(filter.error || '');
      this.sourceChannelChange.next(filter.sourceChannel || '');
      this.anyChange.emit();
    }
  }

  typeChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get type():any {
    return this.typeChange.value;
  }
  set type(type:any) {
    this.typeChange.next(type);
    this.emitChange("type", type);
  }

  textChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get text():any {
    return this.textChange.value;
  }
  set text(text:any) {
    this.textChange.next(text);
    this.emitChange("text", text);
  }

  fromMsisdnChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get fromMsisdn():any {
    return this.fromMsisdnChange.value;
  }
  set fromMsisdn(fromMsisdn:any) {
    this.fromMsisdnChange.next(fromMsisdn);
    this.emitChange("fromMsisdn", fromMsisdn);
  }

  toMsisdnChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get toMsisdn():any {
    return this.toMsisdnChange.value;
  }
  set toMsisdn(toMsisdn:any) {
    this.toMsisdnChange.next(toMsisdn);
    this.emitChange("toMsisdn", toMsisdn);
  }

  userIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get userId():any {
    return this.userIdChange.value;
  }
  set userId(userId:any) {
    this.userIdChange.next(userId);
    this.emitChange("userId", userId);
  }

  chatCarrierIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get chatCarrierId():any {
    return this.chatCarrierIdChange.value;
  }
  set chatCarrierId(chatCarrierId:any) {
    this.chatCarrierIdChange.next(chatCarrierId);
    this.emitChange("chatCarrierId", chatCarrierId);
  }

  companyIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get companyId():any {
    return this.companyIdChange.value;
  }
  set companyId(companyId:any) {
    this.companyIdChange.next(companyId);
    this.emitChange("companyId", companyId);
  }

  statusChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get status():any {
    return this.statusChange.value;
  }
  set status(status:any) {
    this.statusChange.next(status);
    this.emitChange("status", status);
  }

  errorChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get error():any {
    return this.errorChange.value;
  }
  set error(error:any) {
    this.errorChange.next(error);
    this.emitChange("error", error);
  }

  batchIdChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get batchId():any {
    return this.batchIdChange.value;
  }
  set batchId(batchId:any) {
    this.batchIdChange.next(batchId);
    this.emitChange("batchId", batchId);
  }

  sourceChannelChange:BehaviorSubject<any> = new BehaviorSubject<any>('');
  get sourceChannel():any {
    return this.sourceChannelChange.value;
  }
  set sourceChannel(sourceChannel:any) {
    this.sourceChannelChange.next(sourceChannel);
    this.emitChange("sourceChannel", sourceChannel);
  }

  emitChange(prop:string, value:any):void {
    this.anyChange.emit({"prop": prop, "value": value});
  }

  getParams():HttpParams {
    let params:HttpParams = new HttpParams();

    if (this.type && this.type !== '') {
      params = params.set("type", this.type);
    }

    if (this.text && this.text !== '') {
      params = params.set("text", this.text);
    }

    if (this.fromMsisdn && this.fromMsisdn !== '') {
      params = params.set("fromMsisdn", this.fromMsisdn);
    }

    if (this.batchId && this.batchId !== '') {
      params = params.set("batchId", this.batchId);
    }

    if (this.toMsisdn && this.toMsisdn !== '') {
      params = params.set("toMsisdn", this.toMsisdn);
    }

    if (this.userId && this.userId !== '') {
      params = params.set("userId", this.userId);
    }

    if (this.chatCarrierId && this.chatCarrierId !== '') {
      params = params.set("chatCarrierId", this.chatCarrierId);
    }

    if (this.companyId && this.companyId !== '') {
      params = params.set("companyId", this.companyId);
    }

    if (this.status && this.status !== '') {
      params = params.set("status", this.status);
    }

    if (this.error && this.error !== '') {
      params = params.set("error", this.error);
    }

    if (this.sourceChannel && this.sourceChannel !== '') {
      params = params.set("sourceChannel", this.sourceChannel);
    }

    return params;
  }

  toObj():any {
    return {
      chatCarrierId: this.chatCarrierId,
      companyId: this.companyId,
      userId: this.userId,
      batchId: this.batchId,
      fromMsisdn: this.fromMsisdn,
      toMsisdn: this.toMsisdn,
      type: this.type,
      text: this.text,
      status: this.status,
      error: this.error,
      sourceChannel: this.sourceChannel
    }
  }

  public clear():void {
    this.chatCarrierId = undefined;
    this.companyId = undefined;
    this.userId = undefined;
    this.batchId = undefined;
    this.fromMsisdn = undefined;
    this.toMsisdn = undefined;
    this.type = undefined;
    this.text = undefined;
    this.status = undefined;
    this.error = undefined;
    this.sourceChannel = undefined;
  }
}
